const lang = {
  intro: {
    title: "盡享下一次餐饗之樂",
    paragraph:
      "<p>登記並解鎖您的全球餐饗禮遇！我們搜羅逾2,000+間高級餐廳，讓您全年享有總值高達HK$2,000簽賬回贈。本地及海外用餐各享HK$1,000簽賬回贈。</p><p>回贈期分為上半年（2025年1月7日至6月30日）和下半年（2025年7月1日至12月31日），於每個回贈期各可享HK$500本地及海外餐飲簽賬回贈。</p><p>從高檔餐廳到隱藏的本地餐廳，一律滿足您的味蕾需求。您只需選擇心儀的餐廳，並使用美國運通白金卡結賬即享禮遇。</p>",
    tcLink: "查閱餐饗禮遇之詳情及條款細則和不適用項目",
    topBanner: {
      show: false,
      heading: "此餐饗禮遇將於2025年1月中更新。",
      description:
        "目前的登記將有效至2024年12月31日，請密切留意往後的重新登記資訊。",
    },
    hotelRestaurant:
      "*如參與之餐廳位於閣下之住宿酒店內，此禮遇需於餐廳內直接付款，不能掛賬於酒店房間內。",
  },
  filters: {
    country: "國家 或 地區：",
    state: "省：",
    stateDefault: "All states",
    city: "城市：",
    cityDefault: "所有城市",
    cuisine: "菜式：",
    cuisineDefault: "所有料理",
  },
  results: {
    halal: "Halal",
    notAvailable: "此選擇不提供餐廳",
    viewmap: "在地圖上查看",
    makebooking: "立即預訂：",
    makebookingTel: "如需預訂，請致電：",
    orderOnline: "如需預訂，請瀏覽：",
    deliveryTakeaway: "提供外送和外賣",
    deliveryProvidoor: "Delivery available via Providoor",
    openingSoon: "Opening soon",
    onlineOnly: "Online Only",
    new: "新加入",
    locations: "位置",
    button: "點擊查看地點",
    groupCuisine: "不同菜式種類",
    close: "關閉",
    bookNow: "立即預訂",
  },
  tsAndCs: {
    title: "遇條款及細則",
    platinum: {
      html: `<h2>環球餐饗禮遇 (本地餐饗禮遇) - 禮遇條款及細則：</h2><br/><ul> <li>禮遇之有效期為2025年1月7日至2025年12月31日 (「禮遇期」)。</li> <li> 每張已登記卡於每個回贈期內最多可享HK$500簽賬回贈：首個回贈期為2025年1月7日至6月30日；第二個回贈期為2025年7月1日至12月31日 (「禮遇」)。未使用的回贈金額將於每個回贈期後失效。簽賬必須於每個回贈期結束之前記入您的已登記卡賬戶內，才可獲得該期的簽賬回贈。 </li> <li> 僅適用在禮遇期內成功登記此禮遇的美國運通於在香港簽發的美國運通白金卡或美國運通半島白金卡的基本卡（「合資格卡」）。附屬卡或其副卡的交易不適用於此禮遇。 </li> <li> 在參與之本地餐廳 (「本地餐廳」) 使用已登記卡進行簽賬前，您必須先將禮遇儲存至您的合資格卡，方可享有此禮遇。如您在簽賬時使用其他卡，該卡的簽賬將不符合此禮遇資格。 </li> <li> 此禮遇僅適用於親臨香港之本地餐廳堂食簽賬。完整的本地餐廳名單可<a href="https://www.americanexpress.com/zh-hk/benefits/diningbenefit" >在此</a>查看 (「名單」) 。名單可能隨時更改而不作出事先通知，請在消費前查看，以確保餐廳在交易時仍在名單上，否則無法獲得禮遇的簽賬回贈。</li> <li> 此禮遇不適用於購買禮品卡和禮券、支付場所預訂時的訂金、取消預訂及未如期赴約的費用、外賣或到會服務。 </li> <li> 如使用網上付款、二維碼簽賬或在餐廳應用程式中進行簽賬，您可能無法獲得此禮遇。請使用信用卡終端機進行簽賬。 </li> <li> 回贈應在簽賬日期起30天內或禮遇期完結後90天內顯示於您的賬單。回贈不可兌換現金或其他付款方式。 </li> <li> 您在本地餐廳購買商品及/或服務時，受其各自的條款及細則（包括隱私政策）約束。如有關於本地餐廳商品及/或服務的疑問或投訴，請直接聯繫該餐廳。 </li> <li> 若卡會員賬戶已暫停或取消，該回贈可能無法套用至卡會員的賬戶；如果合資格交易已退回或取消，該回贈可能會被撤銷。 </li> <li> 未誌賬／取消／退款的交易或任何被發現為欺詐或最後被取消／退款的交易將不被視為合資格簽賬。 </li> <li> 本地餐廳對所有產品、服務、諮詢和建議全權負責。美國運通並非此優惠所提供的該等產品及／或服務之供應者，亦不對其作出任何表述或保證。 </li> <li> 因享用產品或服務（包括但不限於直接或間接）而造成的損失或破壞，或人身傷害，美國運通概不負責，法律規定之責任除外。 </li> <li>美國運通保留隨時更改本條款及細則或終止優惠之權利，恕不另行通知</li> <li>如對此禮遇有任何疑問，請致電白金卡會員專線2277 2233查詢。</li> <li>有關此禮遇之疑問及爭議，概以美國運通及本地餐廳的最終決定為準。</li> <li>本條款及細則之英、中文版本如有任何差異，概以英文版本為準。</li> <li> <a href="https://www.americanexpress.com/zh-hk/network/amex-offers-terms/index.html" >登記卡推廣條款及細則。</a > </li> </ul><br /><br/><h2>環球餐饗禮遇 (海外餐饗禮遇) - 禮遇條款及細則：</h2><br/> <ul> <li>禮遇之有效期為2025年1月7日至2025年12月31日 (「禮遇期」)。</li> <li> 每張已登記卡於每個回贈期內最多可享HK$500簽賬回贈：首個回贈期為2025年1月7日至6月30日；第二個回贈期為2025年7月1日至12月31日 (「禮遇」)。未使用的回贈金額將於每個回贈期後失效。簽賬必須於每個回贈期結束之前記入您的已登記卡賬戶內，才可獲得該期的簽賬回贈。 </li> <li> 僅適用在禮遇期內成功登記此禮遇的美國運通於在香港簽發的美國運通白金卡或美國運通半島白金卡的基本卡（「合資格卡」）。附屬卡或其副卡的交易不適用於此禮遇。 </li> <li> 在參與之海外餐廳 (「海外餐廳」) 使用已登記卡進行簽賬前，您必須先將禮遇儲存至您的合資格卡，方可享有此禮遇。如您在簽賬時使用其他卡，該卡的簽賬將不符合此禮遇資格。 </li> <li> 此禮遇僅適用於親臨香港以外的海外餐廳堂食簽賬。完整的海外餐廳名單可<a href="https://www.americanexpress.com/zh-hk/benefits/diningbenefit" >在此</a >查看 (「名單」) 。名單可能隨時更改而不作出事先通知，請在消費前查看，以確保餐廳在交易時仍在名單上，否則無法獲得禮遇的簽賬回贈。</li> <li> 位於日本的參與餐廳，您必須以已登記之合資格卡透過Pocket Concierge進行預付預訂。如果預先付款不成功，您將無法獲得該禮遇的簽賬回贈。 其他條款及細則適用，詳情請參閱: <a href="https://pocket-concierge.jp/en/" >https://pocket-concierge.jp/en/</a > </li> <li> 此禮遇不適用於購買禮品卡和禮券、支付場所預訂時的訂金、取消預訂及未如期赴約的費用、外賣或到會服務。外幣交易之相關外幣費用適用，且該外幣費用不計入此禮遇。更多有關外幣交易詳情，請參閱<a href="https://www.americanexpress.com/zh-hk/company/legal/cardmember-agreement-and-fees-and-charges/?inav=hk_ch_footer_noticenagree" >卡會員協議。</a > </li> <li> 如使用網上付款（日本除外）、二維碼簽賬或在餐廳應用程式中進行簽賬，您可能無法獲得此禮遇。請使用信用卡終端機進行簽賬。 </li> <li> 回贈應在簽賬日期起30天內或禮遇期完結後90天內顯示於您的賬單。回贈不可兌換現金或其他付款方式。 </li> <li> 您在海外餐廳購買商品及/或服務時，受其各自的條款及細則（包括隱私政策）約束。如有關於海外餐廳商品及/或服務的疑問或投訴，請直接聯繫該餐廳。 </li> <li> 若卡會員賬戶已暫停或取消，該回贈可能無法套用至卡會員的賬戶；如果合資格交易已退回或取消，該回贈可能會被撤銷。 </li> <li> 未誌賬／取消／退款的交易或任何被發現為欺詐或最後被取消／退款的交易將不被視為合資格簽賬。 </li> <li> 海外餐廳對所有產品、服務、諮詢和建議全權負責。美國運通並非此優惠所提供的該等產品及／或服務之供應者，亦不對其作出任何表述或保證。 </li> <li> 因享用產品或服務（包括但不限於直接或間接）而造成的損失或破壞，或人身傷害，美國運通概不負責，法律規定之責任除外。 </li> <li>美國運通保留隨時更改本條款及細則或終止優惠之權利，恕不另行通知</li> <li>如對此禮遇有任何疑問，請致電2277 2233查詢。</li> <li>有關此禮遇之疑問及爭議，概以美國運通及海外餐廳的最終決定為準。</li> <li>本條款及細則之英、中文版本如有任何差異，概以英文版本為準。</li> <li> <a href="https://www.americanexpress.com/zh-hk/network/amex-offers-terms/index.html" >登記卡推廣條款及細則。</a > </li> </ul>`,
    },
    close: "關閉",
  },
  pocket: {
    title: "Explore 800+ restaurants and book directly with Pocket Concierge",
    button: "Visit Pocket Concierge",
  },
  pocketCard: {
    title: "Pocket Concierge",
    description: "尋找並預訂日本最好的餐廳 (只適用接受預先付款之餐廳)", // "尋找並預訂日本最好的餐廳 (只適用接受預先付款之餐廳)",
    cuisines: "不同菜式種類",
    instruction: "如需預訂，請瀏覽：",
    button: "Visit Pocket Concierge",
  },
  footer: {
    disclaimer:
      "<p>您必須在消費前成功登記才有資格享受此禮遇，並且此禮遇僅適用於美國運通白金卡的基本卡會員。參與之餐廳名單可能隨時更改而不作出事先通知。</p><p>對於位於日本的參與之海外餐廳，您必須以已登記之合資格卡透過Pocket Concierge進行預付預訂。如果不透過Pocket Concierge預先付款，您將無法獲得該禮遇的簽賬回贈。</p>",
  },
  platinumBanner: {
    title: " Explore Platinum Directory",
    text: " Explore all your Card benefits across travel, entertainment,events, insurance and more. Exclusive to Platinum CardMembers.",
    button: "Visit Platinum Benefits Directory",
  },
};

export default lang;
